import { Formik, FormikHelpers } from 'formik';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { withQueryParams } from '@shared/commonFunctions';
import { SaveButton } from '@shared/components/SaveButton';

import { FormWithPrompt } from '@shared/components/FormWithPrompt';
import { TAssetType } from '../../interfaces';
import { requestUpdateAssets } from '../Assets/queries';
import { ILenderUtilityTabProps } from '../LenderUtilityTabs';
import { requestAddLender, requestUpdateGeneral } from '../requests';
import { GeneralForm } from './GeneralForm';
import { lenderUtilityGeneralFormSchema, TLenderUtilityGeneralForm } from './validation';

const defaultAt: TAssetType[] = [
  { assetType: 'Car', isAllowed: true },
  { assetType: 'Truck', isAllowed: true },
  { assetType: 'Suv', isAllowed: true },
];

export const General = ({ data, create, mutate }: ILenderUtilityTabProps) => {
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (values: TLenderUtilityGeneralForm, formikActions: FormikHelpers<TLenderUtilityGeneralForm>) => {
      const formattedData = {
        ...values,
      };

      if (create) {
        const newLender = await requestAddLender(formattedData);

        if (newLender) {
          await requestUpdateAssets(newLender.id, defaultAt);
          mutate?.();
          navigate(withQueryParams('.', { lenderId: newLender.id }));
        } 
      } else {
        const resp = await requestUpdateGeneral(formattedData);
        if (resp?.status === 204) {
          mutate?.();
        }
      }
      formikActions.setSubmitting(false);
    },
    [create, requestAddLender, requestUpdateGeneral]
  );

  const initialState = {
    ...data,
    id: data?.id,
    name: data?.name,
    code: data?.code,
    address: data?.address,
    city: data?.city,
    state: data?.state,
    postCode: data?.postCode,
    contactPhone: data?.contactPhone,
    productCheckRequestPayee: {
      id: data?.productCheckRequestPayee?.id,
      lenderId: data?.productCheckRequestPayee?.lenderId,
      lenderName: data?.productCheckRequestPayee?.lenderName,
      numericId: data?.productCheckRequestPayee?.numericId,
      payeeName: data?.productCheckRequestPayee?.payeeName,
      payeeAddress: data?.productCheckRequestPayee?.payeeAddress,
      payeeState: data?.productCheckRequestPayee?.payeeState,
      payeeZip: data?.productCheckRequestPayee?.payeeZip,
      isPayOffAddressForGAP: data?.productCheckRequestPayee?.isPayOffAddressForGAP,
      gapLoanPaidOffRequestInformation: {
        payeeName: data?.productCheckRequestPayee?.gapLoanPaidOffRequestInformation?.payeeName,
        payeeAddress: data?.productCheckRequestPayee?.gapLoanPaidOffRequestInformation?.payeeAddress,
        payeeState: data?.productCheckRequestPayee?.gapLoanPaidOffRequestInformation?.payeeState,
        payeeZip: data?.productCheckRequestPayee?.gapLoanPaidOffRequestInformation?.payeeZip
      }
    },
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialState as TLenderUtilityGeneralForm}
      validationSchema={lenderUtilityGeneralFormSchema}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <FormWithPrompt>
          <SaveButton disabled={!props.isValid && !!props.submitCount} isLoading={props.isSubmitting}/>
          <GeneralForm
            create={create}
          />
        </FormWithPrompt>
      )}
    </Formik>
  );
};
